import { Component, Inject, OnInit } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { ConfigStorageService } from "src/app/shared/services/config-storage/config-storage.service";
import { CookieService } from "ngx-cookie-service";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";

@Component({
  selector: "welcome-screen-modal",
  templateUrl: "./welcome-screen-modal.component.html",
  styleUrls: ["./welcome-screen-modal.component.scss"],
})
export class WelcomeScreenModalComponent implements OnInit {
  steps: Array<{ text: string; videoUrl: string }> = [];
  dontShowWelcomeAgain = false;

  constructor(
    private http: HttpClient,
    private configStorage: ConfigStorageService,
    private cookieService: CookieService,
    public dialogRef: MatDialogRef<WelcomeScreenModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { modalTitle: string },
  ) {}

  ngOnInit() {
    this.configStorage.load().subscribe((config) => {
      this.steps = config.welcomeScreen.steps;
    });
  }

  closeWelcome() {
    this.dialogRef.close();
  }

  setUnsetCookie() {
    let cookieName = "cyber-skiller-skip-welcome";

    if (this.dontShowWelcomeAgain && !this.cookieService.check(cookieName)) {
      this.cookieService.set(
        cookieName,
        "true",
        730,
        "/",
        undefined,
        undefined,
        "Strict",
      );
    } else if (
      !this.dontShowWelcomeAgain &&
      this.cookieService.check(cookieName)
    ) {
      this.cookieService.delete(cookieName, "/");
    }
  }
}
